export interface StatusConfig {
  glyph: string;
  label: string;
  count?: number;
}

export const getStatusConfigs = (
  serviceRequestOverview?: any
): StatusConfig[] => [
  {
    glyph: 'submitted',
    label: 'Submitted',
    count: serviceRequestOverview?.submittedCount ?? 0,
  },
  {
    glyph: 'under-review',
    label: 'Under Review',
    count: serviceRequestOverview?.underReviewCount ?? 0,
  },
  {
    glyph: 'declined',
    label: 'Declined',
    count: serviceRequestOverview?.declinedCount ?? 0,
  },
  {
    glyph: 'approved',
    label: 'Approved',
    count: serviceRequestOverview?.approvedCount ?? 0,
  },
  {
    glyph: 'assigned',
    label: 'Assigned',
    count: serviceRequestOverview?.assignedCount ?? 0,
  },
  {
    glyph: 'scheduled',
    label: 'Scheduled',
    count: serviceRequestOverview?.scheduledCount ?? 0,
  },
  {
    glyph: 'en-route',
    label: 'En Route',
    count: serviceRequestOverview?.enRouteCount ?? 0,
  },
  {
    glyph: 'in-progress',
    label: 'In Progress',
    count: serviceRequestOverview?.inProgressCount ?? 0,
  },
  {
    glyph: 'on-hold',
    label: 'On Hold',
    count: serviceRequestOverview?.onHoldCount ?? 0,
  },
  {
    glyph: 'warranty',
    label: 'One Year Warranty',
    count: serviceRequestOverview?.oneYearWarrantyCount ?? 0,
  },
  {
    glyph: 'resolved',
    label: 'Resolved',
    count: serviceRequestOverview?.resolvedCount ?? 0,
  },
  {
    glyph: 'closed',
    label: 'Closed',
    count: serviceRequestOverview?.closedCount ?? 0,
  },
];

// Map calendar statuses to dashboard statuses
export const getStatusConfigByLabel = (statusLabel: string): StatusConfig => {
  const normalizedStatus: string = statusLabel?.toLowerCase();
  const allConfigs: StatusConfig[] = getStatusConfigs();

  const directMatch: StatusConfig = allConfigs.find(
    (config: StatusConfig) => config.label.toLowerCase() === normalizedStatus
  );

  if (directMatch) return directMatch;

  // Handle calendar-specific mappings
  const statusMappings: Record<string, string> = {
    begin: 'submitted',
    'in progress': 'in-progress',
    'en route': 'en-route',
    'on hold': 'on-hold',
    'under review': 'under-review',
  };

  const mappedGlyph: string = statusMappings[normalizedStatus];

  if (mappedGlyph) {
    const mappedConfig: StatusConfig = allConfigs.find(
      (config: StatusConfig) => config.glyph === mappedGlyph
    );
    if (mappedConfig) {
      return { ...mappedConfig, label: statusLabel }; // Keep original label.
    }
  }

  // Default fallback.
  return { glyph: 'submitted', label: statusLabel || 'Unknown' };
};
